import type { DxfLayer } from '../types';
import { aciToHex } from './dxf';

/** Match 2D canvas / dxf-parser-api display colors for common MEP layers. */
const LAYER_NAME_HINTS: Array<{ test: (name: string) => boolean; color: string }> = [
  { test: (n) => /OX-LOOP/i.test(n), color: '#ff0000' },
  { test: (n) => /MET-LOOP/i.test(n), color: '#00ff00' },
  { test: (n) => /SMS/i.test(n), color: '#00ffff' },
  { test: (n) => /TEL/i.test(n), color: '#0000ff' },
  { test: (n) => /GRID/i.test(n), color: '#808080' },
  { test: (n) => /DIM/i.test(n), color: '#6b7280' },
];

export function resolveFloor3dLayerStroke(layer: DxfLayer, darkMode: boolean): string {
  for (const hint of LAYER_NAME_HINTS) {
    if (hint.test(layer.name)) return hint.color;
  }
  const fromAci = aciToHex(layer.color);
  if (fromAci) return fromAci;
  return darkMode ? '#94a3b8' : '#475569';
}

export function buildLayerStrokeColors(layers: DxfLayer[], darkMode: boolean): string[] {
  return layers.map((layer) => resolveFloor3dLayerStroke(layer, darkMode));
}
